var WISHLIST_DATA = {};

function initWishlist(pageType) {
    var myHeaders = new Headers();
    myHeaders.append("User-Agent", "Shopify");
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Access-Control-Allow-Origin", "*");

    if (ENV.customerEmail) {
        fetch("/apps/rt/api/wishlist/", 
        {
            method: "POST",
            headers: myHeaders,
            body: '{"email": "' + ENV.customerEmail + '"}',
            redirect: "follow"
        })
        .then((response) => {
            if (!response.ok) {
                throw new Error("Network response was not ok");
            } else {
                return response.json();
            }
        })
        .then((result) => { 
            WISHLIST_DATA = result;
            //console.log(result);
            if (result && result.code == '00') {
                if (pageType == 'collection') {
                    const wishlistItems = document.querySelectorAll('.wishlist.wishlist-icon');
                    wishlistItems.forEach(item => {
                        if (result.LineItems && result.LineItems.length > 0 && result.LineItems.find(li => li.ProductId === item.getAttribute('data-product-handle'))) {
                            item.classList.add('selected');
                        }

                        // prevent adding multiple event listeners
                        item.removeEventListener('click', handleWishlistButtonClick);
                        item.addEventListener('click', function() {handleWishlistButtonClick(item, pageType);});
                    });
                } else { 
                    patchHiddenInput('input[name="selectedVariantId"]');
                    const selectedVariantId = getSelectedVariantIdValue();
                    const wishlistItems = document.querySelectorAll('.wishlist.wishlist-icon.main-product');
                    wishlistItems.forEach(item => {
                        if (result.LineItems && result.LineItems.length > 0 && result.LineItems.find(li => li.SelectedCartVariantId === 'gid://shopify/ProductVariant/' + selectedVariantId)) {
                            item.classList.add('selected');
                        }

                        // Listen for variant changes
                        const mainAddToCartForm = document.querySelector('form[id*="product-form-"]');
                        if (mainAddToCartForm) {
                            const idInput = mainAddToCartForm.querySelector('input[name="id"]');
                            if (idInput) {
                                const hiddenVariantId = document.querySelector('input[name="selectedVariantId"]');
                                hiddenVariantId.value = idInput.value;
                                // prevent adding multiple event listeners
                                hiddenVariantId.removeEventListener('hidden:valuechange', function() {
                                    updatePDPWishlistIconState(getSelectedVariantIdValue());
                                });
                                hiddenVariantId.addEventListener('hidden:valuechange', function() {
                                    updatePDPWishlistIconState(getSelectedVariantIdValue());
                                });
                            }
                        }

                        // Also listen for clicks on the wishlist icon
                        item.removeEventListener('click', function() { handleWishlistButtonClick(item, pageType); });
                        item.addEventListener('click', function() { handleWishlistButtonClick(item, pageType); });
                    });
                }
                
            }
        });
    } else {
        if (pageType == 'collection') {
            const wishlistItems = document.querySelectorAll('.wishlist.wishlist-icon');
            wishlistItems.forEach(item => {
                item.removeEventListener('click', handleWishlistButtonClick);
                item.addEventListener('click', function() {handleWishlistButtonClick(item, pageType);});
            });
        } else { 
            const wishlistItems = document.querySelectorAll('.wishlist.wishlist-icon.main-product');
            wishlistItems.forEach(item => {
                item.removeEventListener('click', function() { handleWishlistButtonClick(item, pageType); });
                item.addEventListener('click', function() { handleWishlistButtonClick(item, pageType); });
            });
        }
    }
}

function addToCartFromWishlist(sku, pageType) {
    // add to cart
    const productId = document.getElementById('wishlist-movetocart-' + sku).getAttribute('data-product-id');
    const handle = document.getElementById('wishlist-movetocart-' + sku).getAttribute('data-product-handle');
    const variantId = pageType == 'product' ? getSelectedVariantIdValue() : document.getElementById('wishlist-movetocart-' + sku).getAttribute('data-first-available-variant-id');

    fetch('/products/' + handle + '.js')
    .then((response) => {
            if (!response.ok) {
                throw new Error("Network response was not ok");
            } else {
                return response.json();
            }
        })
    .then(product => {
        const productTags = product.tags;
        const properties = {};
        if (productTags.includes('final_sale')) {
            properties['Final Sale'] = 'No Return';
        }

        fetch('/cart/add.js', {
            method: 'POST',
            headers: {  'Content-Type': 'application/json' },
            body: JSON.stringify({
                id: variantId,
                quantity: 1,
                properties: properties
            })
        })
        .then(response => { response.json() })
        .then(data => {
            // remove from wishlist
            removeFromWishlist(sku, pageType);
        })
        .catch((error) => {
            console.error('Error:', error);
        });
    });
}

function addToWishlist(item, pageType) {
    var myHeaders = new Headers();
    myHeaders.append("User-Agent", "Shopify");
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Access-Control-Allow-Origin", "*");

    const productId = item.getAttribute('data-product-id');
    const variantId = pageType == 'product' ? getSelectedVariantIdValue() : item.getAttribute('data-first-available-variant-id');
    fetch("/apps/rt/api/wishlist/add", 
    {
        method: "POST",
        headers: myHeaders,
        body: '{"email": "' + ENV.customerEmail + '", "productId": "gid://shopify/Product/' + productId + '", "productVariantId": "gid://shopify/ProductVariant/' + variantId + '"}',
        redirect: "follow"
    })
    .then((response) => {
        if (!response.ok) {
            throw new Error("Network response was not ok");
        } else {
            return response.json();
        }
    })
    .then((result) => { 
        //console.log(result);
        WISHLIST_DATA = result;

        if (pageType == 'wishlist') {
            location.reload();
        } else {
            item.classList.add('selected');
        }
    })
    .catch((error) => {
        console.error('Error:', error);
    });
}

function removeFromWishlist(item, pageType, sku) {
    var myHeaders = new Headers();
    myHeaders.append("User-Agent", "Shopify");
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Access-Control-Allow-Origin", "*");

    const productId = pageType == 'wishlist' ? document.getElementById('wishlist-remove-' + sku).getAttribute('data-product-id') : (pageType == 'product' ? item.getAttribute('data-product-id') : item.getAttribute('data-product-id'));
    const variantId = pageType == 'wishlist' ? document.getElementById('wishlist-remove-' + sku).getAttribute('data-first-available-variant-id') : (pageType == 'product' ? getSelectedVariantIdValue() : item.getAttribute('data-first-available-variant-id'));

    fetch("/apps/rt/api/wishlist/remove", 
    {
        method: "POST",
        headers: myHeaders,
        body: '{"email": "' + ENV.customerEmail + '", "productId": "gid://shopify/Product/' + productId + '", "productVariantId": "gid://shopify/ProductVariant/' + variantId + '"}',
        redirect: "follow"
    })
    .then((response) => {
        if (!response.ok) {
            throw new Error("Network response was not ok");
        } else {
            return response.json();
        }
    })
    .then((result) => { 
        //console.log(result);
        WISHLIST_DATA = result;

        if (pageType == 'wishlist') {
            location.reload();
        } else {
            item.classList.remove('selected');
        }
    })
    .catch((error) => {
        console.error('Error:', error);
    });
}

function renderWishlistHTML() {
    const wishlistContainer = document.getElementById('WishlistContainer');
    const wishlistSection = document.getElementById('WishlistSection');
    const wishlistEmptyMessage = document.getElementById('WishlistEmptyMessage');

    var myHeaders = new Headers();
    myHeaders.append("User-Agent", "Shopify");
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Access-Control-Allow-Origin", "*");

    if (ENV.customerEmail) {
        fetch("/apps/rt/api/wishlist/", 
        {
            method: "POST",
            headers: myHeaders,
            body: '{"email": "' + ENV.customerEmail + '"}',
            redirect: "follow"
        })
        .then((response) => {
            if (!response.ok) {
                throw new Error("Network response was not ok");
            } else {
                return response.json();
            }
        })
        .then((result) => { 
            //console.log(result);

            if (result && result.code == '00' && result.LineItems && result.LineItems.length > 0) {
                const productListHTML = result.LineItems.map(product => {
                    const allSizes = product.Variants.flatMap(item => {
                        return Array.isArray(item.Sizes) ? item.Sizes : [];
                    });
                    const formattedPrice = new Intl.NumberFormat('en-US', {style: 'currency', currency: 'USD'}).format(product.ListPrice);
                    const selectedSKU = allSizes.find(variant => variant.VariantId === product.SelectedCartVariantId);
                    
                    const shopifyProductIdParts = product.ShopifyId.split('/');
                    const shopifyProductId = shopifyProductIdParts[shopifyProductIdParts.length - 1];
                    const parts = product.SelectedCartVariantId.split('/');
                    const SKU = parts[parts.length - 1];
                    return `
                    <div class="cart-item" data-item-row="" data-cart-edit-productitem="" data-line="44929573519539:065e3acc011720c288db40898d9aa10d">
                        <div class="cart-item-block cart-item-info">
                            <div class="cart-item-wrapper">
                                <div class="cart-item-block-left">
                                    <a class="cart-item-image image-portrait" href="/products/dorothy-cardigan-black?variant=44929573519539" style="padding-bottom: 133%">
                                        <svg aria-hidden="true" focusable="false" data-prefix="fal" data-icon="external-link" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="icon icon-external-link"><path d="M440,256H424a8,8,0,0,0-8,8V464a16,16,0,0,1-16,16H48a16,16,0,0,1-16-16V112A16,16,0,0,1,48,96H248a8,8,0,0,0,8-8V72a8,8,0,0,0-8-8H48A48,48,0,0,0,0,112V464a48,48,0,0,0,48,48H400a48,48,0,0,0,48-48V264A8,8,0,0,0,440,256ZM500,0,364,.34a12,12,0,0,0-12,12v10a12,12,0,0,0,12,12L454,34l.7.71L131.51,357.86a12,12,0,0,0,0,17l5.66,5.66a12,12,0,0,0,17,0L477.29,57.34l.71.7-.34,90a12,12,0,0,0,12,12h10a12,12,0,0,0,12-12L512,12A12,12,0,0,0,500,0Z"></path></svg>
                                        <img srcset="${product.SmallSizeProductImage}?v=1755702234" src="${product.SmallSizeProductImage}?v=1755702234" alt="${product.DisplayName} - ${selectedSKU.Title}" sizes="auto" loading="lazy" width="1500" height="2000">
                                    </a>
                                </div>
                                <div class="cart-item-block-right">
                                    <h4 class="cart-item-name">
                                        <a href="/products/${product.ProductId}" class="link link-underline"><span class="text">${product.DisplayName}</span></a>
                                    </h4>
                                    <div class="cart-item-option">
                                        <span class="cart-item-variant">${selectedSKU.Title}</span>
                                    </div>
                                    <dl class="cart-item-properties definitionList"></dl>
                                    <div class="cart-item-block cart-item-price small-screen-visible">
                                        <div class="cart-item__price-wrapper"><span class="price price--end" data-item-final-price-display="">${formattedPrice}</span></div>
                                    </div>
                                    <div class="cart-item-blocks small-screen-visible">
                                        <div class="cart-item-blocks-left">
                                            <div class="cart-item-block cart-item-quantity small-screen-visible">
                                                <span class="cart-item-quantity">${product.SelectedCartQuantity}</span>
                                            </div>
                                        </div>
                                        <div class="cart-item-block cart-item-remove small-screen-visible cart-item-remove-with-saveforlater">
                                            <a class="cart-movetocart" id="wishlist-movetocart-${SKU}" href="javascript:addToCartFromWishlist(this, 'wishlist', ${SKU});" data-product-id="${shopifyProductId}" data-product-handle="${product.ProductId}" data-first-available-variant-id="${SKU}" aria-label="Move To Cart">Add To Cart </a>
                                            <a class="cart-remove-sfl" id="wishlist-remove-${SKU}" href="javascript:removeFromWishlist(this, 'wishlist', ${SKU});" data-product-id="${shopifyProductId}" data-product-handle="${product.ProductId}" data-first-available-variant-id="${SKU}" aria-label="Remove">Remove </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="cart-item-block cart-item-price">
                            <div class="cart-item__price-wrapper"><span class="price price--end" data-item-final-price-display="">${formattedPrice}</span></div>
                        </div>
                        <div class="cart-item-block cart-item-quantity">
                            <span class="cart-item-quantity">${product.SelectedCartQuantity}</span>
                        </div>
                        <div class="cart-item-block cart-item-total" data-price="49500" data-original-price="49500">
                            <span class="cart-item-value" data-item-price-with-quantity-display="">${formattedPrice}</span>
                        </div>
                        <div class="cart-item-block cart-item-remove cart-item-remove-with-saveforlater">
                            <a class="cart-movetocart" id="wishlist-movetocart-${SKU}" href="javascript:addToCartFromWishlist(this, 'wishlist', ${SKU});" data-product-id="${shopifyProductId}" data-product-handle="${product.ProductId}" data-first-available-variant-id="${SKU}" aria-label="Add To Cart">Add To Cart </a>
                            <a class="cart-remove-sfl" id="wishlist-remove-${SKU}" href="javascript:removeFromWishlist(this, 'wishlist', ${SKU});" data-product-id="${shopifyProductId}" data-product-handle="${product.ProductId}" data-first-available-variant-id="${SKU}" aria-label="Remove">Remove</a>
                        </div>
                    </div>
                    `;
                    }).join('');
                
                //console.log(productListHTML);
                wishlistSection.innerHTML = productListHTML;
                wishlistContainer.classList.remove('hidden');
            } else {
                wishlistEmptyMessage.classList.remove('hidden');
            }
        });
    }
}

function handleWishlistButtonClick(item, pageType) {
    if(ENV.customerEmail == null || ENV.customerEmail == '') {
        // show login modal
        showModal('Login Required', 'Please log in to use the wishlist feature.', 'Log In', '/account/login?redirect_after_login=' + encodeURIComponent(window.location.pathname + window.location.search));
        return;
    } else {
        if (item.classList.contains('selected')) {
            // Remove from wishlist
            removeFromWishlist(item, pageType);
        } else {
            // Add to wishlist
            addToWishlist(item, pageType);
        }
    }
}

function updatePDPWishlistIconState(selectedVariantId) {
    const wishlistItems = document.querySelectorAll('.wishlist.wishlist-icon.main-product');
    wishlistItems.forEach(item => {
        item.classList.remove('not-allowed');
        if (selectedVariantId == 'undefined' || selectedVariantId == null) {
            item.classList.add('not-allowed');
            return;
        }

        if (WISHLIST_DATA.LineItems && WISHLIST_DATA.LineItems.find(li => li.SelectedCartVariantId === 'gid://shopify/ProductVariant/' + selectedVariantId)) {
            item.classList.add('selected');
        } else {
            item.classList.remove('selected');
        }

        item.removeEventListener('click', function() {handleWishlistButtonClick(item, 'product');});
        item.addEventListener('click', function() {handleWishlistButtonClick(item, 'product');});
    });
}

function getSelectedVariantIdValue() {
    const mainAddToCartForm = document.querySelector('form[id*="product-form-"]');

    if (!mainAddToCartForm) {
        console.error("error: can't find form with id containing 'product-form-'");
        return null;
    }

    const idInput = mainAddToCartForm.querySelector('input[name="id"]');

    if (idInput && idInput.value) {
        const selectedVariantId = idInput.value;
        
        return selectedVariantId;
    } else {
        console.error("error: can't find input with name 'id' or it has no value");
        return null;
    }
}

function patchHiddenInput(selector) {
    const targetInput = document.querySelector(selector);

    if (!targetInput) {
        console.error(`Error: Input element not found for selector: ${selector}`);
        return;
    }

    let internalValue = targetInput.value;

    Object.defineProperty(targetInput, 'value', {
        get() {
            return internalValue;
        },
        set(newValue) {
            if (internalValue !== newValue) {
                const oldValue = internalValue;
                internalValue = newValue;
                
                const changeEvent = new CustomEvent('hidden:valuechange', {
                    detail: { oldValue, newValue }
                });
                targetInput.dispatchEvent(changeEvent);
            }
        },
        configurable: true
    });
}

function showModal(title, message, actionBtnText, redirectUrl) {
    const modalHTML = `
        <div class="custom-modal-content">
            <span class="custom-modal-close-btn" data-dismiss="modal">&times;</span> 
            
            <h2>${title}</h2>
            <p>${message}</p>

            <div class="custom-modal-footer">
                <button class="custom-modal-action-btn" id="modalActionBtn">
                    ${actionBtnText}
                </button>
            </div>
        </div>
    `;

    const modal = document.createElement('div');
    modal.className = 'custom-modal';
    modal.innerHTML = modalHTML;

    document.body.appendChild(modal);

    const actionBtn = document.getElementById('modalActionBtn');
    actionBtn.addEventListener('click', () => {
        window.location.href = redirectUrl; 
    });

    modal.addEventListener('click', function(event) {
        const isCloseButton = event.target.hasAttribute('data-dismiss');
        const isOutsideClick = event.target === modal;

        if (isCloseButton || isOutsideClick) {
            modal.remove();
        }
    });
}